import { LayoutRoute, MenuItemParams } from 'types/routes/route-params';
import CategoryIcon from '@mui/icons-material/Category';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import AddCardIcon from '@mui/icons-material/AddCard';
import FaceIcon from '@mui/icons-material/Face';
import RuleIcon from '@mui/icons-material/Rule';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import UsersIcon from '@mui/icons-material/Group';
import RedeemIcon from '@mui/icons-material/Redeem';
import Cards from 'pages/cards-sphere/index';

import ProtectedLayout from 'layouts/protected';
import { SecurityTypes } from 'security/security-factory';
import SignIn from 'pages/sign-in';
import PublicLayout from 'layouts/public';
import StaffManagement from 'pages/staff-management';
import CardsPersonage from 'pages/cards-personage';
import Card from 'pages/card';
import Product from 'pages/product/products';
import ProductDetail from 'pages/product/product-detail-page';
import Rule from 'pages/product/rule';
import AddRule from 'pages/product/rule/add-rule';
import AvatarSystems from 'pages/avatar-systems';
import Notification from 'pages/notification';
import Users from 'pages/users';
import UserDetails from 'pages/users/user-details';
import NotificationDetails from 'pages/notification/notification-details';
import Team from 'pages/team';
import TeamInfo from 'pages/team/team-info';
import SystemPresent from 'pages/system -present';
import ToonTintDetails from 'pages/toon-tint';

const layouts: Array<LayoutRoute> = [
    {
        layout: ProtectedLayout,
        name: 'protected',
        routes: [
            /*{
                path: '/dashboard',
                name: 'Dashboard',
                element: Dashboard,
                rules: {
                    securityType: SecurityTypes.Authorized,
                    isMenuItem: true,
                },
            },*/

            {
                path: '/cards-sphere/sphere',
                name: 'Cards',
                element: Cards,
                rules: {
                    securityType: SecurityTypes.Authorized,
                    isMenuItem: true,
                },
            },

            {
                path: '/cards-sphere/personage',
                name: 'Cards Personage',
                element: CardsPersonage,
                rules: {
                    securityType: SecurityTypes.Authorized,
                    isMenuItem: true,
                },
            },

            {
                path: '/card',
                name: 'Card',
                element: Card,
                rules: {
                    securityType: SecurityTypes.Authorized,
                    isMenuItem: true,
                },
            },

            {
                path: '/card/toon-tint/:cardId',
                name: 'Toon Tint Details',
                element: ToonTintDetails,
                rules: {
                    securityType: SecurityTypes.Authorized,
                    isMenuItem: false,
                },
            },

            {
                path: '/product/products',
                name: 'Product',
                element: Product,
                rules: {
                    securityType: SecurityTypes.Authorized,
                    isMenuItem: true,
                },
            },

            {
                path: '/product/rule',
                name: 'Rule',
                element: Rule,
                rules: {
                    securityType: SecurityTypes.Authorized,
                    isMenuItem: true,
                },
            },

            {
                path: '/product/product-detail/:productId?',
                name: 'Product',
                element: ProductDetail,
                rules: {
                    securityType: SecurityTypes.Authorized,
                    isMenuItem: true,
                },
            },

            {
                path: '/product/rule-detail/:ruleId?',
                name: 'Product',
                element: AddRule,
                rules: {
                    securityType: SecurityTypes.Authorized,
                    isMenuItem: true,
                },
            },

            {
                path: '/avatar-system',
                name: 'Avatar',
                element: AvatarSystems,
                rules: {
                    securityType: SecurityTypes.Authorized,
                    isMenuItem: true,
                },
            },

            {
                path: '/notification',
                name: 'Notification',
                element: Notification,
                rules: {
                    securityType: SecurityTypes.Authorized,
                    isMenuItem: true,
                },
            },

            {
                path: '/notification-details-edit/:notificationId/:status?',
                name: 'Notification Details Edit',
                element: NotificationDetails,
                rules: {
                    securityType: SecurityTypes.Authorized,
                    isMenuItem: false,
                },
            },

            {
                path: '/notification-details',
                name: 'Notification Details',
                element: NotificationDetails,
                rules: {
                    securityType: SecurityTypes.Authorized,
                    isMenuItem: false,
                },
            },

            {
                path: '/user',
                name: 'Uses',
                element: Users,
                rules: {
                    securityType: SecurityTypes.Authorized,
                    isMenuItem: true,
                },
            },

            {
                path: '/users/:userId?',
                name: 'Uses',
                element: UserDetails,
                rules: {
                    securityType: SecurityTypes.Authorized,
                    isMenuItem: true,
                },
            },

            {
                path: '/team',
                name: 'Team',
                element: Team,
                rules: {
                    securityType: SecurityTypes.Authorized,
                    isMenuItem: true,
                },
            },

            {
                path: '/team-info/:teamId',
                name: 'Team Info',
                element: TeamInfo,
                rules: {
                    securityType: SecurityTypes.Authorized,
                    isMenuItem: true,
                },
            },
            {
                path: '/system-present',
                name: 'System Present',
                element: SystemPresent,
                rules: {
                    securityType: SecurityTypes.Authorized,
                    isMenuItem: true,
                },
            },
            {
                path: '/staff/management',
                name: 'Staff Management',
                element: StaffManagement,
                rules: {
                    securityType: SecurityTypes.Authorized,
                    isMenuItem: true,
                },
            },
        ],
    },

    {
        layout: PublicLayout,
        name: 'login',
        routes: [
            {
                path: '/',
                name: 'loginName',
                element: SignIn,
                rules: {
                    securityType: SecurityTypes.UnAuthorized,
                },
            },
        ],
    },
];

export const menuItems: Array<MenuItemParams> = [
    /*{
        path: '/dashboard',
        name: 'Dashboard',
        icon: DashboardIcon,
    },*/

    {
        name: 'Card',
        icon: RecentActorsIcon,
        subRoutes: [
            {
                path: '/cards-sphere/sphere',
                name: 'Card Sphere',
                icon: CategoryIcon,
            },
            {
                path: '/cards-sphere/personage',
                name: 'Card Personage',
                icon: ContactEmergencyIcon,
            },
            {
                path: '/card',
                name: 'Card',
                icon: AddCardIcon,
            },
        ],
    },

    {
        name: 'Product',
        icon: ProductionQuantityLimitsIcon,
        subRoutes: [
            {
                path: '/product/products',
                name: 'Product',
                icon: ContactEmergencyIcon,
            },
            {
                path: '/product/rule',
                name: 'Rule',
                icon: RuleIcon,
            },
        ],
    },

    {
        path: '/user',
        name: 'Users',
        icon: UsersIcon,
    },

    {
        path: '/avatar-system',
        name: 'Avatar',
        icon: FaceIcon,
    },

    {
        path: '/notification',
        name: 'Notification',
        icon: NotificationsIcon,
        subRoutes: [
            {
                path: '/notification-details',
                name: 'NotificationDetails',
                icon: ContactEmergencyIcon,
                displayPage: false,
            },
            {
                path: '/notification-details-edit/:notificationId/:status?',
                name: 'NotificationDetailsEdit',
                icon: RuleIcon,
                displayPage: false,
            },
        ],
    },

    {
        path: '/team',
        name: 'Team',
        icon: UsersIcon,
    },

    {
        path: '/system-present',
        name: 'System Present',
        icon: RedeemIcon,
    },

    {
        path: '/staff/management',
        name: 'Staff Management',
        icon: GroupAddIcon,
    },
];
export default layouts;
